import React, { useState } from 'react';

// Connector line between steps — shows a "+" button on hover to insert a node
export function StepConnector({ onInsertClick }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '4px 0',
        position: 'relative',
        cursor: onInsertClick ? 'pointer' : 'default'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{
        width: '2px',
        height: '16px',
        background: '#d1d5db'
      }} />
      <div style={{
        width: 0,
        height: 0,
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        borderTop: '6px solid #d1d5db'
      }} />
      {onInsertClick && isHovered && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onInsertClick();
          }}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            border: '1.5px solid #d1d5db',
            background: '#fff',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            zIndex: 2
          }}
          title="Insert node here"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#6b7280" style={{ width: '14px', height: '14px' }}>
            <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
          </svg>
        </button>
      )}
    </div>
  );
}

// Loop connector drawn on the right side of the Prompt→Respond section
export function LoopConnector() {
  const color = '#d1d5db';
  return (
    <div style={{
      position: 'absolute',
      top: '34px',
      bottom: '34px',
      right: '-36px',
      width: '28px',
      pointerEvents: 'none'
    }}>
      {/* Vertical line on far right */}
      <div style={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: '2px',
        background: color
      }} />
      {/* Top horizontal connector (to Prompt) */}
      <div style={{
        position: 'absolute',
        top: '-1px',
        left: 0,
        right: 0,
        height: '2px',
        background: color
      }} />
      {/* Bottom horizontal connector (from Respond) */}
      <div style={{
        position: 'absolute',
        bottom: '-1px',
        left: 0,
        right: 0,
        height: '2px',
        background: color
      }} />
      {/* Arrow at top pointing left into Prompt */}
      <div style={{
        position: 'absolute',
        top: '-5px',
        left: '-1px',
        width: 0,
        height: 0,
        borderTop: '5px solid transparent',
        borderBottom: '5px solid transparent',
        borderRight: `7px solid ${color}`
      }} />
    </div>
  );
}
